module.exports = __webpack_public_path__ + "img/logoDentaX.a4472715.png";